import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  CSML_EDITOR_HOST: csmlEditorHost,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  csmlEditorHost,
  isEnterprise: parseBoolean(isEnterprise),
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Chatwoot',
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
  getChannelList: () => {
    return [
      // { key: 'facebook', name: 'Messenger' },
      { key: 'whatsapp', name: 'WHATSAPP' },
      { key: 'telegram', name: 'TELEGRAM' },
      { key: 'bale', name: 'BALE' },
      { key: 'eitaa', name: 'EITAA' },
      { key: 'rubika', name: 'RUBIKA' },
      { key: 'website', name: 'WEBSITE' },
      { key: 'sms', name: 'SMS' },
      // { key: 'email', name: 'EMAIL' },
      { key: 'instagram', name: 'INSTAGRAM' },
      { key: 'basalam', name: 'BASALAM' },
      {
        key: 'api',
        name: apiChannelName || 'API',
        thumbnail: apiChannelThumbnail,
      },
      // { key: 'line', name: 'LINE' },
      // { key: 'soroush', name: 'SOROUSH' },
      { key: 'soroushplus', name: 'SOROUSHPLUS' },
      { key: 'divar', name: 'DIVAR' },
      // { key: 'gap', name: 'GAP' },
      // { key: 'igap', name: 'IGAP' },
    ];
  },
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
